export class PhotoMetricContext {
  public clientId = "";
  public coordsTimestamp = "";
}

export class FeedbackMetricContext {
  public clientId = "";
}
